import { QueryClient } from '@tanstack/react-query';

/**
 * Shared React Query client. Defaults tuned for the dashboard's mostly-
 * static widget data:
 *  - staleTime: 30s — within 30 seconds a re-mount uses cached data and
 *    skips the network round-trip entirely. Past that, a background
 *    refetch fires but the UI keeps showing the cached payload (stale-
 *    while-revalidate), so the dashboard never flashes a loading state on
 *    re-navigation.
 *  - gcTime: 5 min — cached entries linger after the last component
 *    unmounts so bouncing away and back is instant.
 *  - refetchOnWindowFocus: true — common ISP-ops pattern: admin alt-tabs
 *    to another tool, comes back, expects fresh data.
 *  - retry: 1 — one silent retry covers transient flakiness without
 *    masking real outages.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
